import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-operation-help',
    templateUrl: './operation-help.component.html',
    styleUrls: ['./operation-help.component.scss'],
    standalone: false
})
export class OperationHelpComponent {
  public translate = inject(TranslateService);
  private dialogRef = inject(MatDialogRef<OperationHelpComponent>);

  public clickCancel(): void {
    this.dialogRef.close();
  }
}

